import { API_BASE_URL } from "@/config";
import { format_date } from "@/utils/date_formatter";
import { validateToken } from "@/utils/auth";
import { LOGOUT } from "@/utils/logout.js";
import AddressForm from "./components/address_form/AddressForm.vue";
import AmlForm from "./components/aml_form/AmlForm.vue";
import CIPCVerificationForm from "./components/cipc_verification_form/CIPCVerificationForm.vue";
import CIPCScore from "./components/cipc_score/CIPCScore.vue";
import CompanyBankAccountForm from "./components/company_bank_account_form/CompanyBankAccountForm.vue";
import EnterpriseAntiMoneyLaunderingForm from "./components/enterprise_anti_money_laundering_form/EnterpriseAntiMoneyLaunderingForm.vue";
import EnterpriseTransUnionKYBForm from "./components/enterprise_transunion_kyb_form/EnterpriseTransUnionKYBForm.vue";
import EnterpriseTransUnionCreditCheckForm from "./components/enterprise_transunion_credit_check_form/EnterpriseTransUnionCreditCheckForm.vue";
import IndividualBankAccountForm from "./components/individual_bank_account_form/IndividualBankAccountForm.vue";
import RefugeeForm from "./components/refugee_form/RefugeeForm.vue";
import QualificationForm from "./components/qualification_form/QualificationForm.vue";
import AFISForm from "./components/afis_form/AFISForm.vue";
import IDForm from "./components/id_form/IDForm.vue";
import TrustNameSearch from "./components/trust_name_search/TrustNameSearch.vue";
import TrustTrusteesSearch from "./components/trust_trustees_search/TrustTrusteesSearch.vue";
import TrustSearchForm from "./components/trust_search_form/TrustSearchForm.vue";
import IncomeEstimatorForm from "./components/income_estimator/IncomeEstimatorForm.vue";
import IncomePredictorForm from "./components/income_predictor/IncomePredictorForm.vue";
import ExperianCreditReportForm from "./components/experian_credit_report_form/ExperianCreditReportForm.vue";
import CreditReportNamibiaForm from "./components/credit_report_namibia_form/CreditReportNamibiaForm.vue";
import TelephoneForm from "./components/telephones_form/TelephoneForm.vue";
import { ANTI_MONEY_LAUNDERING } from "@/utils/constants.js";

import CompanyCreditReport from "@/layouts/pdf_reporting/company_credit_report/CompanyCreditReport.vue";
import AMLReport from "@/layouts/pdf_reporting/aml_reporting/AMLReport.vue";
import ReportViewer from "@/components/v2_report/ReportViewer.vue";
import RefugeeVerificationReport from "@/layouts/pdf_reporting/refugee_verification/RefugeeVerificationReport.vue";
import EnterpriseAmlVerificationReport from "@/layouts/pdf_reporting/enterprise_aml/EnterpriseAmlVerificationReport.vue";
import RsaIdVerificationReport from "@/layouts/pdf_reporting/rsa_id_verification/RsaIdVerificationReport.vue";
import DirectorScreeningReport from "@/layouts/pdf_reporting/director_screening/DirectorScreeningReport.vue";
import TrustSearchReport from "@/layouts/pdf_reporting/trust_search_report/TrustSearchReport.vue";
import CompanyBankAccountReport from "@/layouts/pdf_reporting/bank_account_verification/company_bank_account/CompanyBankAccountReport.vue";
import IndividualBankAccountReport from "@/layouts/pdf_reporting/bank_account_verification/individual_bank_account/IndividualBankAccountReport.vue";
import IncomeEstimatorReport from "@/layouts/pdf_reporting/income_estimator/IncomeEstimatorReport.vue";
import IncomePredictorReport from "@/layouts/pdf_reporting/income_predictor/IncomePredictorReport.vue";
import EnterpriseKYBReport from "@/layouts/pdf_reporting/enterprise_kyb/EnterpriseKYBReport.vue";
import AddressVerificationReport from "@/layouts/pdf_reporting/address_verification/AddressVerificationReport.vue";
import CreditReport from "@/layouts/pdf_reporting/credit_report/CreditReport.vue";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import IconCard from "@/components/CustomCard/IconCard.vue";
import {
  generateRsaIdSummaryPdf,
  generateAmlSummaryPdf,
  generateRefugeeSummaryPdf,
  mapRsaIdSummary,
  mapAmlSummary,
  mapRefugeeSummary,
  mapNamibiaCreditReportSummary,
  preprocessSummaryData,
  exportSummaryData,
} from "@/utils/summary_extractor";

export default {
  name: "ServiceUtilize",
  mixins: [LOGOUT],
  components: {
    AddressForm,
    AmlForm,
    CompanyBankAccountForm,
    EnterpriseAntiMoneyLaunderingForm,
    EnterpriseTransUnionCreditCheckForm,
    EnterpriseTransUnionKYBForm,
    IndividualBankAccountForm,
    RefugeeForm,
    QualificationForm,
    CIPCVerificationForm,
    CIPCScore,
    AFISForm,
    IDForm,
    TrustNameSearch,
    CompanyCreditReport,
    AMLReport,
    ReportViewer,
    RefugeeVerificationReport,
    EnterpriseAmlVerificationReport,
    RsaIdVerificationReport,
    DirectorScreeningReport,
    TrustSearchReport,
    IconCard,
    CompanyBankAccountReport,
    IndividualBankAccountReport,
    IncomeEstimatorForm,
    IncomePredictorForm,
    IncomeEstimatorReport,
    IncomePredictorReport,
    EnterpriseKYBReport,
    AddressVerificationReport,
    ExperianCreditReportForm,
    CreditReportNamibiaForm,
    TelephoneForm,
    CreditReport,
  },
  data() {
    return {
      active_tab: "run_service",
      results: [],
      logs: [],
      aml_data: [],
      search_query: "",
      current_page: 1,
      items_per_page: 10,
      service_name: "",
      service_description: "",
      no_of_attempts: 0,
      no_successful: 0,
      success_rate: 0,
      cost_of_service: 0,
      results_search_date: "",
      results_search_date_from: "",
      results_search_date_to: "",
      results_current_page: 1,
      results_items_per_page: 10,
      service_map: {
        anti_money_laundering: AmlForm,
        bank_account_company_verification: CompanyBankAccountForm,
        enterprise_anti_money_laundering: EnterpriseAntiMoneyLaunderingForm,
        enterprise_kyb: EnterpriseTransUnionKYBForm,
        enterprise_credit_check: EnterpriseTransUnionCreditCheckForm,
        bank_account_individual_verification: IndividualBankAccountForm,
        refugee_verification: RefugeeForm,
        cipc_verification: CIPCVerificationForm,
        qualification_check: QualificationForm,
        afis_criminal_check: AFISForm,
        address_match: AddressForm,
        rsa_id_verification: IDForm,
        trust_name_search: TrustNameSearch,
        trust_trustees_search: TrustTrusteesSearch,
        trust_search: TrustSearchForm,
        income_estimator: IncomeEstimatorForm,
        income_predictor: IncomePredictorForm,
        experian_credit_report: ExperianCreditReportForm,
        credit_report_namibia: CreditReportNamibiaForm,
        telephones: TelephoneForm,
        "experian_credit_report_(pdf)": ExperianCreditReportForm,
        cipc_plus_score: CIPCScore,
      },
      show_export_modal_flag: false,
      summary_export_options: {
        summary: true,
        raw_json: false,
        raw_json_available: false,
      },
      summary_export_format: "csv",
      summary_export_available: false,
    };
  },

  computed: {
    filtered_logs() {
      let filtered = this.logs.filter((log) => {
        return (
          log.status.toLowerCase().includes(this.search_query.toLowerCase()) ||
          log.date.includes(this.search_query) ||
          log.no.toString().includes(this.search_query)
        );
      });
      return filtered.slice(
        (this.current_page - 1) * this.items_per_page,
        this.current_page * this.items_per_page,
      );
    },
    total_pages() {
      return Math.ceil(this.logs.length / this.items_per_page);
    },
    all_filtered_results() {
      let filtered = this.results;

      // Normalize to YYYY-MM-DD for comparison
      const from = this.results_search_date_from
        ? new Date(this.results_search_date_from + "T00:00:00")
        : null;
      const to = this.results_search_date_to
        ? new Date(this.results_search_date_to + "T23:59:59.999")
        : null;

      if (from) {
        filtered = filtered.filter((r) => {
          const rDate = new Date(r.date);
          // Only compare date part
          return rDate >= from;
        });
      }
      if (to) {
        filtered = filtered.filter((r) => {
          const rDate = new Date(r.date);
          // Only compare date part, include the 'to' day
          return rDate <= to;
        });
      }

      return filtered.slice(
        (this.results_current_page - 1) * this.results_items_per_page,
        this.results_current_page * this.results_items_per_page,
      );
    },
    results_total_pages() {
      let filtered = this.results;
      if (this.results_search_date_from) {
        filtered = filtered.filter((result) => {
          return result.date && result.date >= this.results_search_date_from;
        });
      }
      if (this.results_search_date_to) {
        filtered = filtered.filter((result) => {
          return (
            result.date &&
            result.date <= this.results_search_date_to + "T23:59:59"
          );
        });
      }
      return Math.ceil(filtered.length / this.results_items_per_page) || 1;
    },
    filtered_aml_data() {
      let filtered = this.aml_data;

      const from = this.results_search_date_from
        ? new Date(this.results_search_date_from + "T00:00:00")
        : null;
      const to = this.results_search_date_to
        ? new Date(this.results_search_date_to + "T23:59:59.999")
        : null;

      if (from) {
        filtered = filtered.filter((r) => {
          const rDate = new Date(r.date);
          return rDate >= from;
        });
      }
      if (to) {
        filtered = filtered.filter((r) => {
          const rDate = new Date(r.date);
          return rDate <= to;
        });
      }
      return filtered;
    },
    has_selected_summary_export() {
      return (
        this.summary_export_options.summary ||
        this.summary_export_options.raw_json
      );
    },
    backButtonLabel() {
      const domain = window.location.hostname;
      const role = this.$store.getters.get_user_role;
      const targetDomains = ["swift", "mobi", "suzuki", "mobiafrica"];

      if (role === "Client" && targetDomains.some((d) => domain.includes(d))) {
        return "Back to Toolbox";
      }
      return "Back to Services";
    },
  },
  methods: {
    get_result_title(result) {
      const service = this.service_name?.toLowerCase();

      // RSA ID Verification
      if (service.includes("rsa id verification")) {
        const id = result?.data?.response?.IdNumber;
        return id
          ? `Results for: ${id} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // Enterprise AML
      if (service.includes("enterprise anti money laundering")) {
        const name = result?.data?.RequestData?.EnterpriseName;
        return name
          ? `Results for: ${name} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // AML
      if (service.includes("anti money laundering")) {
        const first = result?.response?.RequestData?.FirstName;
        const last = result?.response?.RequestData?.LastName;
        return first || last
          ? `Results for: ${first || ""} ${last || ""} on ${
              result.date_display
            }`
          : `Results on ${result.date_display}`;
      }

      // Enterprise Credit Check
      if (service.includes("enterprise credit check")) {
        const name = result?.data?.CompanySearch?.Name;
        return name
          ? `Results for: ${name} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // Refugee Verification
      if (service.includes("refugee verification")) {
        const fileNo = result?.data?.GoldenSource?.Results?.[0]?.NIISFileNumber;
        return fileNo
          ? `Results for: ${fileNo} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // Address Match
      if (service.includes("address match")) {
        // Find IDNo in result.data array
        const idItem = Array.isArray(result.data)
          ? result.data.find((item) => item.label === "IDNo")
          : null;
        const id = idItem?.value;
        return id
          ? `Results for: ${id} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // Bank Account Individual Verification
      if (service.includes("bank account individual verification")) {
        return `Verification Result: ${this.formatDate(result.date)}`;
      }

      // Bank Account Company Verification
      if (service.includes("bank account company verification")) {
        return `Verification Result: ${this.formatDate(result.date)}`;
      }

      // Trust Search
      if (service.includes("trust search")) {
        const trustName =
          Array.isArray(result.data) && result.data[0]?.TrustName;
        return trustName
          ? `Results for: ${trustName} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // Experian Credit Report
      if (service.includes("experian credit report")) {
        const id = result?.data?.id_number;
        return id
          ? `Results for: ${id} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // Namibia Credit Report
      if (service.includes("credit report namibia")) {
        const id = result?.data?.data?.report?.parameters?.idNumber ||
                   result?.data?.data?.report?.individual?.identifications?.nationalID;
        return id
          ? `Results for: ${id} on ${this.formatDate(result.date)}`
          : `Results on ${this.formatDate(result.date)}`;
      }

      // Default fallback
      return `Verification Result: ${this.formatDate(result.date)}`;
    },

    goBackToServices() {
      this.$router.go(-1);
    },

    aml_results(result) {
      const aml_result =
        result?.response?.Fields?.Applicants_IO?.Applicant?.[0]?.Attributes
          ?.DSWatchlistVerification;
      var request_data = result?.response?.RequestData || {};
      if (!aml_result) return { RequestData: request_data };

      return {
        RequestData: request_data,
        NmResults: aml_result?.NmResults || [],
        PepResults: aml_result?.PepResults || [],
        WlsResults: aml_result?.WlsResults || [],
      };
    },
    response_info_aml(result) {
      const response_info_result = result?.response?.ResponseInfo;
      if (!response_info_result) return {};
      return response_info_result;
    },
    date_scored(result) {
      const date_scored_result =
        result?.response?.Fields?.Applicants_IO?.Applicant?.[0]?.Attributes
          ?.DRWatchlistVerification;
      if (!date_scored_result) return "";
      return date_scored_result?.TimeOfRequest || "";
    },
    formatDate(date) {
      return format_date(date);
    },
    formatDateTime(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "N/A";
      return d.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    },
    service_status_complete(payload) {
      // Trust Search response handling
      if (
        this.service_name?.toLowerCase().includes("trust search") &&
        payload?.response
      ) {
        if (payload.response.status === "error") {
          Swal.fire({
            icon: "info",
            title: "No Results",
            text:
              payload.response.error_message ||
              "Results not found, please contact your service provider",
            timer: 3000,
            showConfirmButton: false,
          });
          return;
        }
        if (payload.response.status === "success") {
          // Switch accordions: close run_service, open view_results
          this.active_tab = "view_results";
          this.get_service_information();
        }
        return;
      }
      this.get_service_information();

      // For CIPC Plus Score, auto-retry if url_link is missing (PDF generation may be async)
      if (this.service_name?.toLowerCase().includes("cipc plus score")) {
        this.schedule_cipc_retry();
      }
    },
    schedule_cipc_retry(retries = 3, delay = 3000) {
      // Check if any CIPC Plus Score result is missing url_link
      const has_missing_url = this.results.some(
        (r) => !r.data?.url_link || !r.data?.url_link?.startsWith("http"),
      );

      if (has_missing_url && retries > 0) {
        setTimeout(() => {
          this.get_service_information_silent().then(() => {
            // Check again and retry if still missing
            const still_missing = this.results.some(
              (r) => !r.data?.url_link || !r.data?.url_link?.startsWith("http"),
            );
            if (still_missing && retries > 1) {
              this.schedule_cipc_retry(retries - 1, delay);
            }
          });
        }, delay);
      }
    },
    get_service_information_silent() {
      // Silent version without loading spinner - for auto-retry
      const TOKEN = localStorage.getItem("token");
      const service_id = this.$route.params.service_id;
      const GET_SERVICE_INFORMATION_API = `${API_BASE_URL}/verify_api/instant_verify_api/user_service_details_api/`;

      return new Promise((resolve) => {
        $.ajax({
          url: GET_SERVICE_INFORMATION_API,
          method: "GET",
          contentType: "application/json",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          data: { service_id: service_id },
          success: (response) => {
            if (response.redirect) {
              this.logout();
              resolve();
              return;
            }
            const data = response.data;
            this.results = data.service_history
              ? this.get_result(data.service_history)
              : [];
            resolve();
          },
          error: () => {
            resolve();
          },
        });
      });
    },
    get_result(results) {
      if (
        this.service_name?.toLowerCase().includes("enterprise credit check") ||
        this.service_name?.toLowerCase().includes("refugee verification") ||
        this.service_name
          ?.toLowerCase()
          .includes("enterprise anti money laundering") ||
        this.service_name
        ?.toLowerCase()
        .includes("telephones") ||
        this.service_name?.toLowerCase().includes("enterprise kyb") ||
        this.service_name?.toLowerCase().includes("rsa id verification") ||
        this.service_name?.toLowerCase().includes("trust search") ||
        this.service_name
          ?.toLowerCase()
          .includes("bank account individual verification") ||
        this.service_name
          ?.toLowerCase()
          .includes("bank account company verification") ||
        this.service_name?.toLowerCase().includes("income estimator") ||
        this.service_name?.toLowerCase().includes("income predictor") ||
        this.service_name?.toLowerCase().includes("address match") ||
        this.service_name?.toLowerCase().includes("experian credit report") ||
        this.service_name?.toLowerCase().includes("cipc plus score") ||
        this.service_name?.toLowerCase().includes("credit report namibia")
      ) {
        let history = [];
        results.forEach((element) => {
          let response = element.response;
          if (!response) {
            response = {};
          }

          history.push({
            date: element.date_created,
            data: response,
            response_doc: element.response_doc,
          });
        });
        return history;
      } else if (
        !this.service_name
          ?.toLowerCase()
          .includes(ANTI_MONEY_LAUNDERING.toLocaleLowerCase())
      ) {
        let history = [];
        results.forEach((element) => {
          let response = element.response;
          if (!response) {
            return;
          }
          try {
            response = this.preprocess_data(response);
          } catch (error) {
            return;
          }

          history.push({
            date: element.date_created,
            data: response,
          });
        });
        return history;
      }
    },
    preprocess_data(data, parent_key = "") {
      let result = [];

      let format_key = (key, parent) => (parent ? `${parent}.${key}` : key);

      Object.entries(data).forEach(([key, value]) => {
        let current_key = format_key(key, parent_key);

        // Special handling for DisplayText
        if (
          key === "DisplayText" &&
          typeof value === "string" &&
          value.trim() !== ""
        ) {
          result.push({
            type: "heading",
            key: current_key,
            label: value,
          });
          return; // Skip further processing for DisplayText
        }

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object" && item !== null) {
              result.push(
                ...this.preprocess_data(item, `${current_key}[${index}]`),
              );
            } else {
              const processed_value =
                item === null || item === undefined || item === ""
                  ? "N/A"
                  : item;
              result.push({
                type: "input",
                key: `${current_key}[${index}]`,
                label: `${key} [${index}]`,
                value: processed_value,
              });
            }
          });
        } else if (typeof value === "object" && value !== null) {
          result.push({
            type: "heading",
            key: current_key,
            label: key,
          });
          result.push(...this.preprocess_data(value, current_key));
        } else if (value !== null && value !== "") {
          result.push({
            type: "input",
            key: current_key,
            label: key,
            value: value,
          });
        }
      });
      return result;
    },
    format_label(key) {
      if (typeof key !== "string" || !key.trim()) return "";

      return key
        .replace(/[_-]/g, " ")
        .replace(/[^a-zA-Z0-9]/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
        .replace(/\s+/g, " ")
        .trim()
        .split(" ")
        .map((word) =>
          typeof word === "string" && word.length > 0
            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            : "",
        )
        .join(" ");
    },
    set_active_tab(tab) {
      this.active_tab = tab;
    },
    toggle_accordion(id) {
      var element = $("#collapse-" + id);
      if (element.length) {
        var is_collapsed = element.hasClass("show");
        if (is_collapsed) {
          element.removeClass("show");
        } else {
          element.addClass("show");

          // Reinitialize DataTable when accordion opens
          this.$nextTick(() => {
            const table = element.find("table.d-none")[0];
            if (table && !$.fn.DataTable.isDataTable(table)) {
              $(table).DataTable({
                responsive: true,
                dom: "Bfrtip",
                buttons: [
                  {
                    extend: "copy",
                    title: this.service_name,
                  },
                  {
                    extend: "csv",
                    title: this.service_name,
                  },
                  {
                    extend: "pdf",
                    title: this.service_name,
                    customize: function (doc) {
                      doc.content.splice(0, 1, {
                        text: table.title,
                        style: "header",
                        alignment: "center",
                        margin: [0, 0, 0, 20],
                      });

                      // Find facial images in the table
                      const image_elements = element.find(
                        "img.facial-image-result",
                      );

                      if (image_elements.length > 0) {
                        // Add a section for images
                        doc.content.push({
                          text: "Image",
                          style: "subheader",
                          margin: [0, 20, 0, 8],
                        });

                        image_elements.each(function () {
                          let img_src = $(this).attr("src");
                          let alt_text = $(this).attr("alt") || "Image";

                          if (img_src && img_src.startsWith("data:image")) {
                            // Add the image as content
                            doc.content.push({
                              image: img_src,
                              width: 100,
                              alignment: "center",
                            });

                            // Add caption
                            doc.content.push({
                              text: alt_text,
                              alignment: "center",
                              margin: [0, 5, 0, 15],
                            });
                          }
                        });
                      }
                    },
                  },
                ],
                order: [[2, "desc"]],
                searching: false,
                paging: false,
                info: false,
              });
            }

            // Handle all AML tables together
            const aml_tables = element.find(".aml-data-table");

            // Make sure all AML tables are visible for download
            aml_tables.removeClass("d-none");

            // Define tables and their section titles
            const tables = [
              { selector: "#nm_result", title: "NM Results" },
              { selector: "#pep_result", title: "PEP/PIP Results" },
              { selector: "#wls_result", title: "Watchlist Results" },
            ];

            // Initialize each table separately with its own title and export buttons
            tables.forEach((table) => {
              const table_element = element.find(table.selector)[0];
              if (table_element && !$.fn.DataTable.isDataTable(table_element)) {
                $(table_element).DataTable({
                  responsive: true,
                  dom: "Bfrtip",
                  buttons: [
                    {
                      extend: "copy",
                      title: table.title,
                      messageTop: table.title,
                    },
                    {
                      extend: "csv",
                      title: table.title,
                      messageTop: table.title,
                    },
                    {
                      extend: "pdf",
                      title: table.title,
                      messageTop: table.title,
                      customize: function (doc) {
                        doc.content.splice(0, 1, {
                          text: table.title,
                          style: "header",
                          alignment: "center",
                          margin: [0, 0, 0, 12],
                        });
                      },
                    },
                  ],
                  searching: false,
                  paging: false,
                  info: false,
                });
              }
            });

            // Add a combined download buttons container for all AML data if it doesn't exist yet
            if (!element.find("#amlExportButtonsContainer").length) {
              const export_buttons_container = `
                                <div id="amlExportButtonsContainer" class="mt-3 mb-5">
                                    <h6 class="text-start"><strong>Export All AML Data</strong></h6>
                                    <div class="dt-buttons" role="group">
                                        <button class="dt-button buttons-copy buttons-html5" id="copyAllAmlData">Copy All</button>
                                        <button class="dt-button buttons-csv buttons-html5" id="csvAllAmlData">CSV</button>
                                        <button class="dt-button buttons-pdf buttons-html5" id="pdfAllAmlData">PDF</button>
                                    </div>
                                    <br>
                                </div>
                            `;

              element.find(".aml-card-body").prepend(export_buttons_container);

              // Function to get table data
              const getTableData = (table_id, title) => {
                const table = element.find(table_id);
                if (table.length === 0) return null;

                const headers = [];
                table.find("thead th").each(function () {
                  headers.push($(this).text().trim());
                });

                const rows = [];
                table.find("tbody tr").each(function () {
                  const row = [];
                  $(this)
                    .find("td")
                    .each(function () {
                      row.push($(this).text().trim());
                    });
                  rows.push(row);
                });

                return { title, headers, rows };
              };

              // Copy All button
              $("#copyAllAmlData").on("click", () => {
                let copyText = "";
                tables.forEach((table) => {
                  const data = getTableData(table.selector, table.title);
                  if (data) {
                    copyText += data.title + "\n";
                    copyText += data.headers.join("\t") + "\n";

                    data.rows.forEach((row) => {
                      copyText += row.join("\t") + "\n";
                    });

                    copyText += "\n"; // Add space between tables
                  }
                });

                // Copy to clipboard
                const textarea = document.createElement("textarea");
                textarea.value = copyText;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);

                // Show copy confirmation
                alert("All AML data copied to clipboard!");
              });

              // CSV All button
              $("#csvAllAmlData").on("click", () => {
                let csvContent = "data:text/csv;charset=utf-8,";

                tables.forEach((table) => {
                  const data = getTableData(table.selector, table.title);
                  if (data) {
                    csvContent += data.title + "\n";
                    csvContent += data.headers.join(",") + "\n";

                    data.rows.forEach((row) => {
                      // Escape commas in the data
                      const escaped_row = row.map((cell) => {
                        if (cell.includes(",")) {
                          return `"${cell}"`;
                        }
                        return cell;
                      });
                      csvContent += escaped_row.join(",") + "\n";
                    });

                    csvContent += "\n"; // Add space between tables
                  }
                });

                // Create download link
                const encoded_uri = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", encoded_uri);
                link.setAttribute("download", "AML_Data_Report.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              });

              $("#pdfAllAmlData").on("click", () => {
                const doc = new jsPDF("l", "mm", "a4"); // Set to landscape mode

                // Set document metadata
                doc.setProperties({
                  title: "AML Data Report",
                  subject: "Anti Money Laundering Data Report",
                  author: "System Generated",
                  keywords: "AML, Report, Data",
                });

                // Define styling constants
                const styles = {
                  title: { fontSize: 18, fontStyle: "bold" },
                  sectionHeader: { fontSize: 14, fontStyle: "bold" },
                  tableHeader: { fontSize: 10, fillColor: [22, 160, 133] },
                  tableContent: { fontSize: 9, cellPadding: 2 },
                };

                // Add main title
                doc.setFontSize(styles.title.fontSize);
                doc.setFont(undefined, "bold");
                doc.text(
                  "AML Data Report",
                  doc.internal.pageSize.getWidth() / 2,
                  15,
                  { align: "center" },
                );

                let yPosition = 30; // Starting position after title

                // Process each table section
                tables.forEach((table, index) => {
                  const tableElement = element.find(table.selector);
                  if (
                    tableElement.length > 0 &&
                    tableElement.find("tbody tr").length > 0
                  ) {
                    // Add page break if needed
                    if (
                      yPosition > doc.internal.pageSize.getHeight() - 40 &&
                      index > 0
                    ) {
                      doc.addPage();
                      yPosition = 30;
                    }

                    // Add section header
                    doc.setFontSize(styles.sectionHeader.fontSize);
                    doc.setFont(undefined, "bold");
                    doc.text(table.title, 10, yPosition);

                    // Extract table data
                    const headers = [];
                    const data = [];

                    // Get headers
                    tableElement.find("thead th").each(function () {
                      headers.push($(this).text().trim());
                    });

                    // Get row data
                    tableElement.find("tbody tr").each(function () {
                      const row = [];
                      $(this)
                        .find("td")
                        .each(function () {
                          row.push($(this).text().trim());
                        });
                      data.push(row);
                    });

                    // Add table using autoTable
                    autoTable(doc, {
                      startY: yPosition + 5,
                      head: [headers],
                      body: data,
                      theme: "grid",
                      styles: {
                        fontSize: styles.tableContent.fontSize,
                        cellPadding: styles.tableContent.cellPadding,
                        overflow: "linebreak",
                        cellWidth: "wrap",
                      },
                      headStyles: {
                        fillColor: styles.tableHeader.fillColor,
                        fontSize: styles.tableContent.fontSize,
                        textColor: [255, 255, 255],
                        fontStyle: "bold",
                      },
                      columnStyles: {
                        // Adjust column widths based on content type
                        0: { cellWidth: 25 }, // ID columns
                        1: { cellWidth: 20 }, // Score
                        2: { cellWidth: 30 }, // Source/Profile ID
                        3: { cellWidth: 35 }, // Category/Name
                        4: { cellWidth: 25 }, // Country
                        5: { cellWidth: 35 }, // Additional info
                        6: { cellWidth: "auto" }, // Longer text content
                        7: { cellWidth: "auto" }, // URLs and highlights
                      },
                      margin: { top: 30, left: 10, right: 10 },
                      didDrawPage: function () {
                        // Add header to each page
                        doc.setFontSize(12);
                        doc.text("AML Data Report - " + table.title, 10, 10);

                        // Add page number
                        doc.setFontSize(8);
                        doc.text(
                          "Page " +
                            doc.internal.getCurrentPageInfo().pageNumber,
                          doc.internal.pageSize.getWidth() - 20,
                          10,
                          { align: "right" },
                        );
                      },
                    });

                    // Update position for next table
                    yPosition = doc.lastAutoTable.finalY + 15;
                  }
                });

                // Add footer with timestamp
                const timestamp = new Date().toLocaleString();
                doc.setFontSize(8);
                doc.text(
                  `Report generated on: ${timestamp}`,
                  10,
                  doc.internal.pageSize.getHeight() - 10,
                );

                // Save the PDF
                doc.save("AML_Data_Report.pdf");
              });
            }
          });
        }
      }
    },
    is_accordion_open(id) {
      var element = $("#collapse-" + id);
      return element.hasClass("show");
    },
    previous_page() {
      if (this.current_page > 1) {
        this.current_page--;
      }
    },
    next_page() {
      if (this.current_page < this.total_pages) {
        this.current_page++;
      }
    },
    results_previous_page() {
      if (this.results_current_page > 1) {
        this.results_current_page--;
      }
    },
    results_next_page() {
      if (this.results_current_page < this.results_total_pages) {
        this.results_current_page++;
      }
    },
    get_log(results) {
      var logs = [];
      this.logs = results.forEach((element, indexOf) => {
        logs.push({
          no: indexOf + 1,
          status: element.api_result_status,
          date: element.date_created,
        });
      });
      logs.sort((a, b) => new Date(b.date) - new Date(a.date));
      return logs;
    },
    preprocess_aml_data(raw_aml_data) {
      // Ensure each AML entry has a 'date' property for filtering and a formatted 'date_display' for UI
      return (raw_aml_data || []).map((entry) => {
        let date_raw = entry.date_created || entry.date || "";
        let date = "";
        if (date_raw) {
          const d = new Date(date_raw);
          if (!isNaN(d)) {
            date = date_raw;
          }
        }
        return {
          ...entry,
          date, // standardized date property for filtering
          date_display: this.formatDateTime(date_raw), // formatted date for display
        };
      });
    },
    get_service_information() {
      const TOKEN = localStorage.getItem("token");
      const service_id = this.$route.params.service_id;
      const GET_SERVICE_INFORMATION_API = `${API_BASE_URL}/verify_api/instant_verify_api/user_service_details_api/`;

      $.ajax({
        url: GET_SERVICE_INFORMATION_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: { service_id: service_id },
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          if (response.redirect) {
            this.logout();
            return;
          }
          const data = response.data;
          this.service_name = data.service.service_name;
          this.service_description = data.service_details.service_description;
          this.no_of_attempts = data.number_of_requests;
          this.no_successful = data.number_success;
          this.success_rate =
            data.number_of_requests !== 0
              ? ((data.number_success / data.number_of_requests) * 100).toFixed(
                  2,
                )
              : "0.00";
          this.cost_of_service = data.cost.total_cost;
          this.logs = data.service_log ? this.get_log(data.service_log) : [];
          if (
            this.service_name?.toLowerCase() ===
            ANTI_MONEY_LAUNDERING.toLocaleLowerCase()
          ) {
            // Preprocess AML data for consistent date filtering
            this.aml_data = this.preprocess_aml_data(
              data.service_history || [],
            );
          } else {
            this.results = data.service_history
              ? this.get_result(data.service_history)
              : [];
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Failed to get service information";
          if (error.responseJSON) {
            const ERROR_RESPONSE = error.responseJSON;
            if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
              error_message = ERROR_RESPONSE.error;
            }
          }
          Swal.fire({
            icon: "error",
            title: "Error",
            text: error_message,
            confirmButtonText: "OK",
          });
        },
      });
    },
    clear_results_filters() {
      this.results_search_date_from = "";
      this.results_search_date_to = "";
      this.results_current_page = 1;
    },
    check_document_url(item) {
      return (
        item.label === "url_link" &&
        typeof item.value === "string" &&
        item.value.startsWith("http")
      );
    },
    download_results_summary() {
      let summaryData = [];
      const from = this.results_search_date_from;
      const to = this.results_search_date_to;

      if (this.service_name?.toLowerCase().includes("rsa id verification")) {
        summaryData = this.all_filtered_results;
        generateRsaIdSummaryPdf(summaryData, from, to);
      } else if (
        this.service_name?.toLowerCase().includes("anti money laundering")
      ) {
        summaryData = this.filtered_aml_data;
        generateAmlSummaryPdf(summaryData, from, to);
      } else if (
        this.service_name?.toLowerCase().includes("refugee verification")
      ) {
        summaryData = this.all_filtered_results;
        generateRefugeeSummaryPdf(summaryData, from, to);
      }
      // ...other services...
    },
    show_export_modal() {
      this.summary_export_options.summary = true;
      this.summary_export_options.raw_json = false;
      this.summary_export_options.raw_json_available =
        !!this.all_filtered_results.length;
      this.summary_export_format = "csv";
      this.show_export_modal_flag = true;
      setTimeout(() => {
        $("#summary-export-modal").modal("show");
      }, 10);
    },
    close_export_modal() {
      this.show_export_modal_flag = false;
      $("#summary-export-modal").modal("hide");
    },
    async ensure_export_libs_loaded() {
      if (this.summary_export_format === "csv" && typeof Papa === "undefined") {
        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src =
            "https://cdnjs.cloudflare.com/ajax/libs/PapaParse/5.4.1/papaparse.min.js";
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      if (
        this.summary_export_format === "excel" &&
        typeof XLSX === "undefined"
      ) {
        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src =
            "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
    },
    async export_summary_link(format) {
      let summary = [];
      let results = preprocessSummaryData(this.all_filtered_results);

      if (this.service_name?.toLowerCase().includes("rsa id verification")) {
        summary = mapRsaIdSummary(results);
      } else if (
        this.service_name?.toLowerCase().includes("anti money laundering")
      ) {
        summary = mapAmlSummary(this.filtered_aml_data);
      } else if (
        this.service_name?.toLowerCase().includes("refugee verification")
      ) {
        summary = mapRefugeeSummary(results);
      } else if (
        this.service_name?.toLowerCase().includes("credit report namibia")
      ) {
        summary = mapNamibiaCreditReportSummary(this.all_filtered_results);
      } else {
        summary = results;
      }

      await exportSummaryData(summary, format, this.service_name);
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }

    this.get_service_information();
    this.summary_export_available = true; // Enable export button if summary data exists
  },
};
